import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

/** Sur mobile : contenu replié avec bouton "Lire la suite". Sur desktop : toujours visible. */
const MobileCollapse = ({ label = 'Lire la suite', children, testId = 'mobile-collapse' }) => {
  const [open, setOpen] = useState(false);
  return (
    <div data-testid={testId}>
      <div className={`${open ? '' : 'hidden'} md:block`}>{children}</div>
      {!open && (
        <div className="md:hidden px-4 py-6 text-center">
          <button
            type="button"
            onClick={() => setOpen(true)}
            data-testid={`${testId}-toggle`}
            className="inline-flex items-center gap-2 text-blue-600 font-semibold text-base underline-offset-4 hover:underline"
          >
            {label}
            <ChevronDown className="w-5 h-5" />
          </button>
        </div>
      )}
    </div>
  );
};

export default MobileCollapse;
